import { ReactComponent as AssetSvg } from '../assets/car-hatchback-svgrepo-com.svg';
import React from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

const Car = (props: {style?: CSSProperties; className?: string}) => {
    return (
        <AssetSvg className={props.className} />
    );
}

export { Car };